export default "__VITE_ASSET__CNIsN5v5__"